var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.043 7.038-5.128-.476-2.038-4.73a.411.411 0 0 0-.754 0l-2.038 4.73-5.128.476a.411.411 0 0 0-.233.718l3.87 3.4L4.46 16.18c-.08.351.3.627.61.443l4.429-2.63 4.429 2.63c.31.184.69-.092.61-.443l-1.132-5.025 3.87-3.4a.411.411 0 0 0-.234-.717z",
    fill: "#FFE17D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.877 1.832a.411.411 0 0 0-.754 0l-2.038 4.73-5.128.476a.411.411 0 0 0-.233.718l3.87 3.4L4.46 16.18c-.08.351.3.627.61.443l.989-.587c.137-5.631 2.753-9.597 4.825-11.865L9.877 1.83z",
    fill: "#FFD164"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallStar);
export default __webpack_public_path__ + "static/media/small-star.095a1709.svg";
export { ForwardRef as ReactComponent };